import React from 'react';
import cupIcon from '#/src/static/img/cup.svg';

import { usePromoRating } from './usePromoRating';

import { styles } from './styles';
import { createUseStyles } from 'react-jss';
import { Place } from './Place'
import Dropdown from '#/src/components/Dropdown';
import { RATING_CONFIG_BY_TYPE } from '#/src/containers/Filter/PromoRating/constants'
import waterWaveIcon from '#/src/static/img/water-wave-facebook.png';

const useStyles = createUseStyles(styles);

export const PromoRating = React.memo(() => {
  const {
    currentRating,
    currentPlace,
    handleChangeSelectedRatingType,
    showSelectType,
    selectedRatingIndex,
    ratingDescription,
    ratingTypesOptions,
  } = usePromoRating();
  const styles = useStyles();

  if (!currentRating || !currentPlace) {
    return null;
  }

  return (
    <div>
      <div className={styles.titleWrapper}>
        <img width={50} height={50} src={waterWaveIcon} alt="placeIcon" />
        <div className={styles.titleContentWrapper}>
          <div className={styles.title}>
            ПУТЬ К АЛЬФА-РЕГАТЕ
          </div>
          <div className={styles.titleDescription}>Конкурс с 01.11.2024 по 28.02.2025</div>
        </div>
      </div>
      <div className={styles.plate}>
        {showSelectType && (
          <Dropdown
            name="ratingTypePicker"
            toggleClassName={styles.ratingTypePicker}
            defaultText="Рейтинг"
            list={ratingTypesOptions}
            defaultActive={ selectedRatingIndex }
            onSelectItem={handleChangeSelectedRatingType}
          />
        )}
        <div className={styles.content}>
          <p>{ratingDescription}</p>
          <div
            className={styles.place}
          >
            <img
              src={cupIcon}
              width={24}
              alt='cup'
            />
            <span>ТОП-{currentRating.topLimit}</span>
          </div>
          <Place
            current={currentPlace}
            rating={currentRating}
            ratingIcon={RATING_CONFIG_BY_TYPE[currentRating.ratingType].ratingIcon}
            scoreUnits={RATING_CONFIG_BY_TYPE[currentRating.ratingType].scoreUnits}
          />
        </div>
      </div>
    </div>
  );
});
